/**
 * Image with text overlay — sections/image-with-text-overlay.liquid
 * Equal-width caption buttons after load (theme editor); window resize uses theme utils.resizeActionButtons.
 */
(function () {
  'use strict';

  if (window.__iwtoAssets) {
    return;
  }
  window.__iwtoAssets = true;

  function isVisible(el) {
    if (!el || !el.getClientRects) return false;
    if (el.getClientRects().length === 0) return false;
    var s = window.getComputedStyle(el);
    return s.display !== 'none' && s.visibility !== 'hidden' && s.opacity !== '0';
  }

  function syncSection(sectionEl) {
    var root = sectionEl.querySelector('image-with-text-overlay.image-with-text-overlay-root') || sectionEl;
    var captions = root.querySelectorAll('.js-caption');
    Array.prototype.forEach.call(captions, function (cap) {
      if (!isVisible(cap)) return;
      var buttons = cap.querySelectorAll('.action_button');
      if (!buttons.length) return;

      Array.prototype.forEach.call(buttons, function (btn) {
        btn.style.width = '';
      });

      var maxW = 0;
      Array.prototype.forEach.call(buttons, function (btn) {
        var w = btn.offsetWidth;
        if (w > maxW) maxW = w;
      });
      if (!maxW) return;

      Array.prototype.forEach.call(buttons, function (btn) {
        btn.style.width = maxW + 'px';
      });
    });
  }

  function bindDesignModeClickGuards(scope) {
    if (!(window.Shopify && window.Shopify.designMode)) return;

    var root = scope && scope.querySelectorAll ? scope : document;
    var guardedLinks = root.querySelectorAll(
      'image-with-text-overlay.image-with-text-overlay-root a.banner-full-link, image-with-text-overlay.image-with-text-overlay-root .js-caption a.action_button'
    );

    Array.prototype.forEach.call(guardedLinks, function (link) {
      if (link.getAttribute('data-iwto-editor-guard') === '1') return;
      link.setAttribute('data-iwto-editor-guard', '1');
      link.addEventListener('click', function (ev) {
        ev.preventDefault();
      });
    });
  }

  function syncAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.image-with-text-overlay-section'), function (sec) {
      syncSection(sec);
    });
  }

  function init() {
    syncAll();
    bindDesignModeClickGuards(document);
    if (window.utils && typeof window.utils.resizeActionButtons === 'function') {
      window.utils.resizeActionButtons();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var t = ev.target;
    if (!t || !t.classList || !t.classList.contains('image-with-text-overlay-section')) return;
    syncSection(t);
    bindDesignModeClickGuards(t);
    if (window.utils && typeof window.utils.resizeActionButtons === 'function') {
      window.utils.resizeActionButtons();
    }
  });
})();
